'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import { getUser } from 'api/index'
import { fetchMyPrompt } from 'api/meditation/meditationapis'
// import axios from 'axios'
// const isServer = process.env.VUE_ENV === 'server'
Vue.use(Vuex)
export default function createStore(initState) {
  const store = new Vuex.Store({
    state: () => ({
      userinfo: null,
      meta: {
        title: '壹心理',
        description: '',
        keywords: ''
      },
      isInput: false, // 输入框状态
      inputParams: {}, // 输入框参数
      myPrompt: {
        commentNum: 0,
        actualLike: 0,
        externalLike: 0,
        followerNum: 0
      },
      ...initState
    }),
    mutations: {
      setMeta(state, meta) {
        // let _meta = {}
        // for (let key in meta) {
        //   if (meta[key]) {
        //     _meta[key] = meta[key]
        //   }
        // }
        // console.log('@store: setMeta', meta)
        state.meta = {
          ...state.meta,
          ...meta
        }
      },
      setUserInfo(state, userinfo) {
        state.userinfo = userinfo
      },
      toggleInput(state, params = {}) {
        state.isInput =
          params.isInput !== undefined ? params.isInput : !state.isInput
        state.inputParams = params
        console.log(state.inputParams, state.isInput)
        setTimeout(() => {
          // let el = document.getElementById('fixedInputText')
          if (state.isInput) {
            // el.focus()
            // el.scrollIntoView()
          } else {
            // window.scrollTo(window.scrollLeft, 100) //设置y轴滚动一百像素
            state.inputParams = {}
          }
        }, 200)
      },
      setMyPrompt(
        state,
        { commentNum = 0, actualLike = 0, externalLike = 0, followerNum = 0 }
      ) {
        state.myPrompt = {
          commentNum,
          actualLike,
          externalLike,
          followerNum
        }
      }
    },
    getters: {
      loginUser(state) {
        const { userinfo } = state
        return userinfo && !Array.isArray(userinfo) ? userinfo : {}
      },
      isLogin: state => state.userinfo && !Array.isArray(state.userinfo),
      qingtingInfo: (state, getters) => {
        if (getters.isLogin && state.userinfo && state.userinfo.qingting) {
          const { qingting, __fetchTime } = state.userinfo
          return Object.assign(
            {
              __fetchTime
            },
            qingting
          )
        } else {
          return null
        }
      },
      consultTeacherInfo: (state, getters) => {
        if (getters.isLogin && state.userinfo && state.userinfo.teacher) {
          return state.userinfo.teacher
        } else {
          return null
        }
      }
    },
    actions: {
      getUserInfo({ state, commit }, fetch = false) {
        if (this.getUserInfoPromise && !fetch) return this.getUserInfoPromise
        if (state.userinfo && !fetch) {
          return Promise.resolve(state.userinfo)
        }
        this.getUserInfoPromise = getUser()
          .then(res => {
            if (res.code === 0) {
              if (!Array.isArray(res.data.user)) {
                res.data.user.__fetchTime = new Date().getTime()
              }
              console.log('setuser', res.data.user)
              commit('setUserInfo', res.data.user)
              return Promise.resolve(res.data.user)
            }
            this.getUserInfoPromise = null
            return Promise.reject(res)
          })
          .catch(e => {
            this.getUserInfoPromise = null
            return Promise.reject(e)
          })
        return this.getUserInfoPromise
      },
      getMyPrompt({ commit }, { channelId }) {
        fetchMyPrompt({ channelId })
          .then(res => {
            if (+res.code === 1 && res.data) {
              commit('setMyPrompt', {
                commentNum: +res.data.commentNum || 0,
                actualLike: +res.data.actualLike || 0,
                externalLike: +res.data.externalLike || 0,
                followerNum: +res.data.followerNum || 0
              })
            }
          })
          .catch(err => {
            console.log('fetchMyPrompt error: ' + err)
          })
      }
      // setTitle({commit}, title) {
      //   commit('')
      // }
    }
  })
  return store
}
